import { TextInput, TextArea } from 'carbon-components-react';
import Select from 'react-select';
import CreatableSelect from "react-select/creatable";
import SelectLabel from '../../../components/SelectLabel';
import HyperLinkButtonArray from './detailConneX/HyperLinkButtonArray';
import HyperLinkButtonSingle from './detailConneX/HyperLinkButtonSingle';
// styles
import {
  selectStyles,
  getSelectValuesToSubmit,
  getValuesForReactSelect,
} from '../../../helpers/formUtils'
import './DetailManual.scss';

const DetailManual = ({
  data,
  dirtyFields,
  dataToSubmit,
  setDataToSubmit,
  SET_SPONSOR_DATA,
  SET_RELATED_STUDIES,
  SET_COMMERCIAL_PRODUCTS,
  SET_DEVELOPMENT_STATUS,
  simpleStudyList,
  relatedStudyOptions,
  commercialProducts,
  developmentStatuses,
}) => {

  const placeboItems = [
    { value: "1", label: "Yes" },
    { value: "2", label: "No" },
  ]

  const commercialProductOptions = commercialProducts?.map((element) => ({
    value: String(element.id),
    label: element.name
  }))

  const developmentStatusOptions = developmentStatuses?.map((element) => ({
    value: String(element.id),
    label: element.name
  }))

  /** EVENT HANDLERS */

  const onTextFieldChange = (evt) => {
    const name = evt.target.id
    let value = evt.target.value
    setDataToSubmit({ type: SET_SPONSOR_DATA, name, value })
  }

  const onSelectChange = (selectedItems, evtObject) => {
    const name = evtObject.name
    let value = null
    if (name === 'related_studies') {
      value = selectedItems?.map((select) => {
        return simpleStudyList?.find((study) => study.id === select.value)
      })
      setDataToSubmit({ type: SET_RELATED_STUDIES, name, value })
    } else if (name === 'possibility_of_active_intervention') {
      value = getSelectValuesToSubmit(selectedItems, evtObject)
      setDataToSubmit({ type: SET_SPONSOR_DATA, name, value })
    } else if (name === "commercial_products") {
      value = selectedItems?.map((select) => {
        return commercialProducts?.find((element) => element?.id === select.value)
      })
      setDataToSubmit({ type: SET_COMMERCIAL_PRODUCTS, name, value })
    } else if (name === "development_status") {
      value = developmentStatuses?.find((element) => element?.id === selectedItems.value)
      setDataToSubmit({ type: SET_DEVELOPMENT_STATUS, name, value })
    }
  }

  /** RENDERERS */

  const getTextField = (id, label) => {
    return <div className={`detail-manual__text-field${dirtyFields?.sponsor_data?.[id] ? ' detail-manual__text-field--dirty' : ''}`}>
      <TextInput
        id={id}
        labelText={label}
        size="sm"
        defaultValue={data?.sponsor_data?.[id]}
        onChange={onTextFieldChange}
        onInput={onTextFieldChange}
      />
    </div>
  }

  const getTextAreaField = (id, label) => {
    return <div className={`detail-manual__text-field${dirtyFields?.sponsor_data?.[id] ? ' detail-manual__text-field--dirty' : ''}`}>
      <TextArea
        id={id}
        labelText={label}
        size="sm"
        defaultValue={data?.sponsor_data?.[id]}
        onChange={onTextFieldChange}
        onInput={onTextFieldChange}
      />
    </div>
  }

  const getSelectField = (id, label, options, isMulti = false) => {

    const getValuesforRelatedStudySelect = (values) => {
      return values?.map((study) => ({
        value: study.id, label: study.org_study_id,
      }))
    }

    const getValuesforCommercialProductSelect = (values) => {
      return values?.map((element) => ({
        value: element.id, label: element.name,
      }))
    }

    const getValuesForDevelopmentStatusSelect = (values) => {
      return  {
        value: values?.id,
        label: values?.name
      }
    }

    let defaultValue = null
    let dirtyValue = null
    if (id === 'related_studies') {
      defaultValue = getValuesforRelatedStudySelect(data?.related_studies)
      dirtyValue = dirtyFields?.related_studies
    } else if (id === 'possibility_of_active_intervention') {
      defaultValue = getValuesForReactSelect(data?.sponsor_data?.[id], options)
      dirtyValue = dirtyFields?.sponsor_data?.[id]
    } else if (id === "commercial_products") {
      defaultValue = getValuesforCommercialProductSelect(data?.commercial_products)
      dirtyValue = dirtyFields?.commercial_products
    }
    else if (id === "development_status") {
      defaultValue = getValuesForDevelopmentStatusSelect(data?.development_status)
      dirtyValue = dirtyFields?.development_status
    }
    return <>
      <SelectLabel
        id={`manual-data-${id}`}
        htmlFor={`manual-data-${id}`}
      >
        {label}
      </SelectLabel>
      <Select
        name={id}
        aria-labelledby={`manual-data-${id}`}
        defaultValue={defaultValue}
        options={options}
        isMulti={isMulti}
        onChange={onSelectChange}
        styles={selectStyles({ isDirty: dirtyValue })}
      />
    </>
  }

  return (
    <div className="detail-manual__grid">
      <div className="detail-manual__field">
        {getTextField('participation_requirements', 'Participation Requirements / Participation Duration')}
      </div>

      <div className="detail-manual__field">
        <SelectLabel
          id="manual-data"
          htmlFor="manual-data"
        >
          Keywords
        </SelectLabel>
        <CreatableSelect
          isMulti
          options={[]}
          defaultValue={Array.isArray(data?.sponsor_data?.keyword_phrase) && data?.sponsor_data?.keyword_phrase.map((element) => ({
            value: element,
            label: element,
          }))}
          onChange={(value) => {
            let submitValue = []
            if(value.length > 0){
              value.map((element) => {
                submitValue.push(element.value)
              })
            }
            setDataToSubmit({ type: SET_SPONSOR_DATA, name: "keyword_phrase", value: submitValue })
          }}
        />
      </div>

      <div className="detail-manual__field">
        {getSelectField('possibility_of_active_intervention', 'Placebo?', placeboItems)}
      </div>

      <div className="detail-manual__field">
        {getSelectField('related_studies', 'Related / Sister Studies', relatedStudyOptions, true)}
      </div>

      <div className="detail-manual__field">
        {getTextField('vivli_search_link', 'Vivli Search Link')}
      </div>

      <div className="detail-manual__field">
        {getTextField('drug_name', 'Drug Treatment Name')}
      </div>

      <div className="detail-manual__field">
        {getSelectField('development_status', 'Development Status', developmentStatusOptions, false)}
      </div>

      <div className="detail-manual__field">
        {getSelectField('commercial_products', 'Commercial Products', commercialProductOptions, true)}
      </div>
    </div>
  );
};

export default DetailManual;
